import React, { useEffect, useState } from 'react';
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer
} from 'recharts';

const UserComparison = () => {
  const user = JSON.parse(sessionStorage.getItem('user'));
  const [users, setUsers] = useState([]);
  const [selectedUserID, setSelectedUserID] = useState('');
  const [comparisonResult, setComparisonResult] = useState(null);
  const [selectedActivities, setSelectedActivities] = useState([]);

  const activityFields = ['workout', 'walking', 'cycling', 'running', 'yoga', 'meditation', 'swimming'];

  useEffect(() => {
    const fetchUsers = async () => {
      const res = await fetch('https://18.117.231.157/api/getAllUsers');
      const data = await res.json();
      if (data.success) {
        const filtered = data.users.filter(u => u.userID !== user.userID);
        setUsers(filtered);
      }
    };
    fetchUsers();
  }, [user.userID]);

  const compareProgress = async () => {
    const res = await fetch('https://18.117.231.157/api/compareUserProgress', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ user1ID: user.userID, user2ID: selectedUserID })
    });

    const result = await res.json();
    if (result.success) {
      setComparisonResult(result.data);
      setSelectedActivities(activityFields); // Select all by default
    }
  };

  const toggleActivity = (activity) => {
    setSelectedActivities(prev =>
      prev.includes(activity)
        ? prev.filter(a => a !== activity)
        : [...prev, activity]
    );
  };

  const barData = selectedActivities.map(activity => ({
    activity: activity.charAt(0).toUpperCase() + activity.slice(1),
    You: comparisonResult?.[activity]?.user1 || 0,
    Other: comparisonResult?.[activity]?.user2 || 0
  }));

  return (
    <div className="logTile" style={{ padding: '1rem' }}>
      <h2 style={{ textAlign: 'center' }}>Compare Progress With Another User</h2>

      <select
        value={selectedUserID}
        onChange={e => setSelectedUserID(e.target.value)}
        className="form-control"
      >
        <option value="" disabled>Select a user...</option>
        {users.map(u => (
          <option key={u.userID} value={u.userID}>
            {u.firstName} {u.lastName} ({u.email})
          </option>
        ))}
      </select>

      <button
        className="submitbutton"
        style={{ marginTop: '1rem' }}
        onClick={compareProgress}
        disabled={!selectedUserID}
      >
        Compare
      </button>

      {comparisonResult && (
        <>
          <div >
            <h3 style={{ textAlign: 'center' }}>Select Activities to Compare</h3>
            <div className="checkboxes-grid">
              {activityFields.map(activity => (
                <div className='columntype'>
                <label key={activity} style={{ margin: '0.5rem' }}>
                  <input
                    type="checkbox"
                    checked={selectedActivities.includes(activity)}
                    onChange={() => toggleActivity(activity)}
                  />
                  {' '}{activity.charAt(0).toUpperCase() + activity.slice(1)}
                </label>
                </div>
              ))}
            </div>
          </div>

          <div style={{ width: '100%', height: 400, marginTop: '2rem' }}>
            <ResponsiveContainer width="95%" height="100%">
              <BarChart data={barData}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="activity" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Bar dataKey="You" fill="#8884d8" />
                <Bar dataKey="Other" fill="#82ca9d" />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </>
      )}
    </div>
  );
};

export default UserComparison;
